<count-up :delay="delay" :options="{useEasing: true, useGrouping: false}" :endVal="value"/>